import { render } from "./ProjectAdd.vue?vue&type=template&id=7bff6b2c"
import script from "./ProjectAdd.vue?vue&type=script&lang=js"
export * from "./ProjectAdd.vue?vue&type=script&lang=js"

import "./ProjectAdd.vue?vue&type=style&index=0&id=7bff6b2c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__